import { ADD, ADDTOCART, LESS } from "./actionType";

const initialState = {
  value: 0,
};
const ValueReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDTOCART:
      if (action.payload.quantity === 0) {
        action.payload.stockOut = true;
      } else {
        return {
          ...state,
          value: state.value + 1,
        };
      }
      return state;

    case ADD:
      if (action.payload.quantity === 0) {
        action.payload.stockOut = true;
      } else {
        return {
          ...state,
          value: state.value + 1,
        };
      }
      return state;
    case LESS:
      return {
        ...state,
        value: state.value - 1,
      };

    default:
      return state;
  }
};
export default ValueReducer;
